/**
 * Application configuration
 */

// API Base URL - in production, use same origin since Express serves both frontend and API
export const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? window.location.origin
    : 'http://localhost:3001');

// Initial user balance
export const INITIAL_BALANCE = 10000;

// Stock price update interval (ms)
export const PRICE_UPDATE_INTERVAL = 3000;

// Stock data polling interval (ms)
export const STOCK_DATA_POLLING_INTERVAL = 5000;

// Market events
export const MARKET_EVENTS = {
  CRASH: 'MARKET_CRASH',
  BULL_RUN: 'BULL_RUN',
  STOCK_SPLIT: 'STOCK_SPLIT',
  MERGER: 'MERGER',
  SCANDAL: 'SCANDAL'
};

// Trade types
export const TRADE_TYPES = {
  LONG: 'LONG',
  SHORT: 'SHORT'
};

// Max shares per trade
export const MAX_SHARES_PER_TRADE = 100;

// App version
export const APP_VERSION = '1.0.0';